import { convertFapiaoDisplayDetails, convertFapiaoOrganizationRequest } from 'shared/view/fapiao-conversion-service';
import { actions as accountActions } from 'shared/account';
import * as c from './constants';
export var createFapiao = function createFapiao(fapiaoCreationRequest) {
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post("/api/fapiao", fapiaoCreationRequest)).then(function (json) {
      var error = json.error,
        fapiao = json.fapiao;
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error.error
        }));
      } else {
        dispatch(application.addMessage({
          type: 'success',
          message: "fapiao-creation-success-type-".concat(fapiao.type)
        }));
      }
      return json;
    });
  };
};
export var loadFapiaos = function loadFapiaos() {
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    dispatch(accountActions.loadAccount('/api/account'));
    return dispatch(application.get('/api/fapiao')).then(function (json) {
      var _convertFapiaoDisplay = convertFapiaoDisplayDetails(json),
        fapiaos = _convertFapiaoDisplay.fapiaos;
      return fapiaos;
    });
  };
};
export var loadPaddleFapiaos = function loadPaddleFapiaos() {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    dispatch(accountActions.loadAccount('/api/account'));
    return dispatch(application.get('/api/fapiao?context=Paddle')).then(function (json) {
      var _convertFapiaoDisplay2 = convertFapiaoDisplayDetails(json),
        fapiaos = _convertFapiaoDisplay2.fapiaos;
      return fapiaos;
    });
  };
};
export var cancelFapiao = function cancelFapiao(_ref4) {
  var identity = _ref4.identity,
    type = _ref4.type;
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    return dispatch(application.del("/api/fapiao/".concat(identity))).then(function (json) {
      dispatch(application.addMessage({
        type: 'success',
        message: "fapiao-cancellation-success-type-".concat(type)
      }));
      return json;
    });
  };
};
export var findFapiaoOrganizations = function findFapiaoOrganizations(_ref6) {
  var name = _ref6.name;
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.get('/api/fapiao/organizations', {
      name: name
    })).then(function (json) {
      var _convertFapiaoOrganiz = convertFapiaoOrganizationRequest(json),
        organizations = _convertFapiaoOrganiz.organizations;
      dispatch({
        type: c.ORGANIZATIONS_LOADED,
        organizations: organizations
      });
      return organizations.map(function (_ref8) {
        var organizationName = _ref8.organizationName;
        return organizationName;
      });
    });
  };
};
export default createFapiao;